<div class="main mat-typography mat-body">
  <div class='div-left'>
    <div>
      <h3 class="sub-header">
        <slot name="text_two">Enter state and Agency Details</slot>
      </h3>
      <div class='sub-text'>
        <slot name="subText_two">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </slot>
      </div>
    </div>
    <form [formGroup]="agencyForm" (submit)="submit(agencyForm)">
      <!-- Agency Name-->
      <div class="agency-preferences-container">
        <mat-form-field appearance="outline" class="agency-preferences">
          <mat-select formControlName="agency" (selectionChange)="agencyChange($event.value)">
            @for (agency of agenciesForDisplay; track agency) {
              <mat-option [value]="agency">
                {{agency.agencyName}} - {{agency.region}}
              </mat-option>
            }
          </mat-select>
          <mat-hint>{{ getPreferredAgencyHint() }}</mat-hint>
        </mat-form-field>
        <!-- REMEMBER ME -->
        @if (userInfo.agencyIdPref !== agencyForm.controls['agency'].value.agencyId || userInfo.regionPref !== agencyForm.controls['agency'].value.region) {
          <mat-checkbox
            formControlName="rememberSelection">
            {{ 'Change your Preferred Agency to ' + agencyForm.controls['agency'].value.agencyName + ' - ' +
            agencyForm.controls['agency'].value.region}}
          </mat-checkbox>
        }

        <div>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>National Producer Number *</mat-label>
            <input matInput formControlName="npnNumber" pattern="[0-9]*"
              placeholder="{{selectedMarket === linesOfBusiness.senior ? 'ABC5555555' : 'Agency Id'}}" maxlength='8'
              type="text">
              @if (agencyForm.controls['npnNumber'].errors?.pattern) {
                <mat-error>NPN must be numbers only
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div>

        </div>
        <div class='sub-text' [ngClass]="{'no-visibility' : hideZipcode}">
          <slot name="subText_three">
            Add client's zip code and county information to view products.
          </slot>
        </div>

        <ptl-zip-code-and-county-select
          ignoreCookieUpdates="true"
          [ngClass]="{'no-visibility' : hideZipcode}"
          (zipAndCountyChanged)="zipCountyChanged($event)" [preloadedValues]="stateValues">
        </ptl-zip-code-and-county-select>

        <div class="button-and-errors">
          <div class="errors">
            <!-- ERRORS -->
            @if (regionMismatch) {
              <mat-error>
                Selected agency region does not match the zipcode
              </mat-error>
            }
          </div>
        </div>

        <!-- Layout Container for AEM -->
        <slot name="layout_container_1">
        </slot>

        <!--  -->
        @if (isFieldAgent) {
          <div>
            <mat-checkbox formControlName="isOnCallWithFieldAgent">
              <slot name="subText_four">
                Are you on call with client?
              </slot>
            </mat-checkbox>
          </div>
        }

        <div class="button-centerer" [ngClass]="{'no-visibility' : hideZipcode}">
          <!-- SUBMIT -->
          <button type="submit" mat-raised-button color="primary"
          [disabled]="!agencyForm?.valid || (hideZipcode && (regionMismatch || !saveableCounty))" class="primary-btn">View Plans</button>
        </div>
      </form>
    </div>
    <div class='div-right'>
      <slot name="img_welcome"></slot>
    </div>
  </div>
